/**
 * The product-tile geometry, shared by every surface that lays product tiles out
 * on a detail page — the range row, the similar-products row and its standalone
 * mobile section, the supplier carousels, and the professional page's Products
 * grid.
 *
 * Both values mirror the /products browse grid so a product tile is the same
 * card wherever it appears: the browse tile's 354/459 card and the browse
 * grid's column gap and row rhythm. Read these rather than restating them.
 */

/** The browse product grid: 2-up on mobile, 4-up from md, with its gaps. */
export const PRODUCT_TILE_GRID =
    'grid grid-cols-2 gap-x-2 gap-y-12 md:grid-cols-4 md:gap-x-6 md:gap-y-[6.25rem]';

/**
 * The browse product card's ratio. Stated per breakpoint because it overrides
 * `DetailTileCard`'s own `max-md:` / `md:` aspect pair — an unprefixed class
 * can't win against a variant-prefixed one.
 */
export const PRODUCT_TILE_MEDIA =
    'max-md:aspect-tile-product-tall md:aspect-tile-product-tall';
